import { Component, Fragment, useCallback, useEffect, useRef, useState } from "react";
import { PageData, SiteData } from "../Data/SiteData";
import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import CreateNewGUID from "vagaro-website-rendering/src/components/Utilities/CreateNewGUID";
import LightGearIcon from "../Icons/LightGearIcon";
import DeleteIcon from "../Icons/DeleteIcon";
import { DuplicateIcon } from "../Icons/DuplicateIcon";
import ReactDOM from "react-dom";
import WebDesigner, {  SaveType } from "../WebDesigner";
import {
  AlertConfirm,
  Confirmation,
  DestructiveConfirmation,
  GenericConfirmation,
} from "../ConfirmationPopups";
import {
  CreateOrUpdatePage,
  DeletePageAsync,
  DisableFolder,
  HideFolder,
  DuplicateAllLocationFolder,
  LoadPageContentAsync,
  SavePageAsync,

  SavePageStructure,
  SaveSiteStyle,
  getAllPagesContentless,
} from "../Utilities/PageDataHandler";
import FileUpload from "../../Controls/FileUpload.jsx";
import { UploadImage } from "../Utilities/FileUploadUtility";
import { CreatePageDataFromAPI } from "../WebDesignerManager";
import ToggleLine from "../Utilities/ToggleLine";
import HoverToolTip from "../HoverToolTip";
import HamburgerIcon from "vagaro-website-rendering/src/components/Icons/Hamburger";
import { CreateBlankLayoutNode } from "../WBCanvas";
import Loader from "components/Common/Loader";

import { ReservedURLSlugs } from "../Data/WBData";
import ConnectDomainClickAd from "../Adds/ConnectDomainClickAd";
import store from "app/store";
import { CustomColorToast } from "../Toast";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import ProcessNodes from "../Utilities/ProcessNodes";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { MultiLocationLive } from "components/Multilocation/MulitLocationLIve";
import { LoginUserType } from "utils/Utils";



function CreateSavePageObjectFromPageData(page: PageListItem,layoutId:string,styleId:string) :{
  PageId: string;
  LayoutId: string;
  StyleId: string;
  PageName: string;
  UrlSlug?: string;
  TitleTag?: string;
  Description?: string;
  IsFolder: boolean;
  FolderId?: string;
  IsDisable: boolean;
  OpenGraphURL: string;
  IsLandingPage: boolean;
  IsHidePage: boolean;
  isExternalLink?:boolean;
  IsExternalLinkNewTab?:boolean;
  externalLinkURL:string;
  

  IsDuplicateAllLocationPage:boolean;
} {
  return {
    PageId: page.id??"",
    LayoutId: layoutId,
    StyleId: styleId,
    PageName: page.name,
    UrlSlug: (page.isExternalLink) ? "" : "/" + page.url, // for now generate a random url for external links since it can't be a duplicate
    TitleTag: (page.isExternalLink)?(page.isExternalLinkNewTab?"_blank":"_self"): page.titleTag,
    Description:(page.isExternalLink)?"":  page.metaDescription,
    IsFolder: page.type == PageType.Folder,
    FolderId: page.folderId,
    IsDisable:(page.isExternalLink)?false:  page.isDisabled,
    OpenGraphURL: page.openGraphImageUrl,
    IsLandingPage: page.isLandingPage,
    IsHidePage: (page.isExternalLink)?false: page.isHidePage,
    isExternalLink: page.isExternalLink,
    externalLinkURL: (page.isExternalLink) ? page.url : "",
    IsDuplicateAllLocationPage: page.isDuplicateAllLocationPage,
    IsExternalLinkNewTab:page.isExternalLinkNewTab
  };
  
  

}

const getFormattedTitleTag = (pageName:string,bName:string)=>{

  if(pageName){
    if(bName&&bName.length>0)
      return `${pageName} - ${bName}`;
  else
    return pageName;

  }
else
  return bName;
}

export type PagesMenuProps = {
  siteData: SiteData;
  webDesigner: WebDesigner;
};

export type PageMenuState = {
  pageList: PageListItem[];
  dragState: DragState;
  draggedPage: PageListItem | null;
  mouseY: number;
  pageMenuOpen: boolean;
  editingPage: PageListItem | null;
  isLoading: boolean;
  tempPage:PageListItem|null;
};

enum PageType {
  Folder,
  Page,
  EndFolder,
  EndList,



  AddPage,
  AddFolder,
}

type PageListItem = {
  type: PageType;
  name: string;
  url: string;
  index: number;
  isNested: boolean;
  folderName: string;
  folderId?: string;
  folderContents?: PageListItem[] | null;
  id: string;
  titleTag?: string;
  isExternalLink?:boolean;
  
  metaDescription?: string;
  isDisabled: boolean;
  openGraphImageUrl: string;
  isLandingPage: boolean;
  isHidePage: boolean;
  isDuplicateAllLocationPage:boolean;
  isExternalLinkNewTab?:boolean;
};
const pageHeight = 36;
const maximumPageNameLength = 24;
enum DragState {
  none,
  preDrag,
  dragging,
}


function RestAllLocationData (root:LayoutNode){
let found = false;
  ProcessNodes(root,(node:LayoutNode)=>{

    if(node.data){
      node.data = null;
     found = true;
    }

  })

  return found;
}

const maxNumberOfPages = 99;
export default class PagesMenu extends Component<
  PagesMenuProps,
  PageMenuState
> {
  hasDragged = false;
  containerRef: React.RefObject<HTMLDivElement>;
  fullPageList: PageListItem[] = [];
  folderPageList: PageListItem[] = [];
  mouseDownPosition = 0;
  bName:string = "";

  originalIndex = 0;
  hasDragStarted = () => {
    return this.mouseDownPosition < -9999;
  };

  constructor(props: PagesMenuProps) {
    super(props);

    this.state = {
      dragState: DragState.none,
      pageMenuOpen: false,
      editingPage: null,
      pageList: CompilePageList(props.siteData.pages),
      draggedPage: null,
      mouseY: 0,
      tempPage: null,
      isLoading: false,
    };

    this.containerRef = React.createRef<HTMLDivElement>();

    // this.startDrag = this.startDrag.bind(this);
    this.endDrag = this.endDrag.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.RenderPageListItem = this.RenderPageListItem.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.collapseAllFolders = this.collapseAllFolders.bind(this);
    this.expandAllFolders = this.expandAllFolders.bind(this);
    this.addPageOrFolderAtIndex = this.addPageOrFolderAtIndex.bind(this);
    this.calculateNesting = this.calculateNesting.bind(this);
    this.setYPos = this.setYPos.bind(this);
    this.startClick = this.startClick.bind(this);
    this.assignAllIndexes = this.assignAllIndexes.bind(this);
    this.openPageMenu = this.openPageMenu.bind(this);
    this.saveToSiteData = this.saveToSiteData.bind(this);
    this.reloadPages = this.reloadPages.bind(this);
    this.getIndexedCopyName = this.getIndexedCopyName.bind(this);
    this.duplicateMultiplePages = this.duplicateMultiplePages.bind(this);
    this.deletePages = this.deletePages.bind(this);
    this.AutoAssignHomePage = this.AutoAssignHomePage.bind(this);

    this.bName = this.props.webDesigner.props.businessName??"";
    if(this.props.siteData.userContext.isAdmin){
      this.bName = "";
    }

    let bIndex = this.bName.indexOf("(");
    if(bIndex>0){
      this.bName = this.bName.substring(0,bIndex).trim();
    }

  }

  componentDidMount(): void {
    document.addEventListener("pointerup", this.endDrag);
    document.addEventListener("touchmove", this.handleTouchMove, {
      passive: false,
      capture: true,
    });
    document.addEventListener("pointermove", this.handleMouseMove);
  }
  componentWillUnmount(): void {
    document.removeEventListener("pointerup", this.endDrag);
    document.removeEventListener("pointermove", this.handleMouseMove);
    document.removeEventListener("touchmove", this.handleTouchMove);
  }

  getIndexedCopyName(name: string,pageType:PageType) {

    let copyIndex = 1;
  
    const strIndex = name.indexOf(" Copy (");
    if(strIndex>0 &&name.endsWith(")")){
      name = name.substring(0,strIndex).trim();
    }

    
    
    let newName = name+" Copy (1)";
    for(let i = 0;i<this.state.pageList.length;i++){
      const compare = this.state.pageList[i];
      if(compare.type === pageType && compare.name.trim() === newName.trim()){
        copyIndex++;
        newName = name+" Copy ("+copyIndex+")";
        i = 0;
      }

      
    }
    return newName;

  }


  tryChangePage(page: PageListItem|null) {

 
    const tempPage = this.state.tempPage;
    const editingPage = this.state.editingPage;

    let flagChange = false;

    const execChange = ()=>{
      if(page){
        this.openPageMenu(page);
      }
      else{
        this.closePageMenu();
      }
    }

    if(tempPage && editingPage){

      if(tempPage.name != editingPage.name||tempPage.isDisabled != editingPage.isDisabled)
        flagChange = true;
     
      if(tempPage.isExternalLinkNewTab??false != (editingPage.isExternalLinkNewTab??false)){
       
      
        flagChange = true;

      }

      if(tempPage.name != editingPage.name||tempPage.isHidePage != editingPage.isHidePage)
        flagChange = true;

      if(editingPage.type === PageType.Page){
        if(tempPage.url != editingPage.url || tempPage.titleTag != editingPage.titleTag || tempPage.metaDescription != editingPage.metaDescription || tempPage.openGraphImageUrl != editingPage.openGraphImageUrl)
          flagChange = true;

      }
        
      if(!flagChange || !this.props.siteData.isModifyAllowed){
        execChange();
      }
      else{
        GenericConfirmation(
          `You have unsaved ${
            editingPage.type == PageType.Page ? "page" : "folder"
          } changes, are you sure you want to close without saving?`,
          () => {
            execChange();
          },
          () => {
 
          },
          "page-close-cnfm",
          "Close without saving",
          "Close",
          "Cancel",
          true
        );
      }
  


    }
    else{
      execChange();
    }



  }

  async deletePages(pages: PageListItem[],onFinished:Function = ()=>{}) {

    this.setState({ isLoading: true });
    let pageList = this.state.pageList;
    let promises:any = [];

    let shouldUnload = false;

    for (let i = 0; i < pages.length; i++) {
      if (pages[i].type != PageType.AddPage) {
        promises.push(
          DeletePageAsync(
            this.props.siteData.userContext,
            pages[i].id,
            (data: any) => {},
            (data: any) => {}
          )
        );

        if(pages[i].id == this.props.webDesigner.state.currentPageId){
          shouldUnload = true;
        }
      }
    }

    await Promise.all(promises);

    for(let i = 0;i<pages.length;i++){
      let index = pageList.indexOf(pages[i]);
      pageList.splice(index,1);
    }


    this.setState({pageList:pageList});
     this.calculateNesting(pageList,true,true);
    this.setState({ isLoading: false });
    
    onFinished();
    if(shouldUnload){
    this.props.webDesigner.setState({currentPageId:"",layout:CreateBlankLayoutNode()});
    setTimeout(() => {

      for(let i = 0;i<this.props.siteData.pages.length;i++){
        if(this.props.siteData.pages[i].isLandingPage){
          if(this.props.siteData.pages[i].isExternalLink)
            this.props.webDesigner.tryLoadPage(this.props.siteData.pages[i].pageId);
          break;
        }
      }

    })
      
  }
  }


  async duplicateMultiplePages(copyStart:number,copyEnd:number,insertStart:number) {

 
    this.setState({ isLoading: true });
    const loads:any[] = [];
    const saves:any[] = [];
    const pages = this.state.pageList;
    let inc = 0;
    for(let i = copyStart;i<copyEnd;i++){

      const page = pages[i];
      if(page.type!=PageType.Page)
        continue;
 
      await this.addPageOrFolderAtIndex(
        false,
        insertStart + inc,
        false,
        this.getIndexedCopyName(page.name,page.type),
        page.isDisabled,
        page.isHidePage,
        page.isDuplicateAllLocationPage,
        (newPage: PageListItem) => {
          newPage.isDisabled = page.isDisabled;
          newPage.isHidePage = page.isHidePage;
          newPage.isDuplicateAllLocationPage = page.isDuplicateAllLocationPage;
          newPage.titleTag = page.titleTag;
          newPage.metaDescription = page.metaDescription;
          newPage.openGraphImageUrl = page.openGraphImageUrl;
          newPage.isExternalLink = page.isExternalLink;
          newPage.isExternalLinkNewTab = page.isExternalLinkNewTab;
          if(!newPage.isExternalLink)
          loads.push( LoadPageContentAsync(
            this.props.siteData.userContext,
            page.id,
            (data: any) => {
              let content = data.data.data.content;

              saves.push(SavePageAsync(
                false,
                this.props.siteData.userContext,
                newPage.id,
                content,
                (data: any) => {
                
        
               
                },
                (data: any) => {
                  
                }
              ));
            },
            (data: any) => {
              AlertConfirm(
                "Error Duplicating Page, Please Try Again Later"
              );
           
            }
          ));
        },
        () => {
       
        }
      ,false,false,page.isExternalLink);

      inc ++;

    }
    
    await Promise.all(loads);
    await Promise.all(saves);
    await  this.saveToSiteData();


   
      this.calculateNesting(); 
      this.props.webDesigner.setState({siteData: this.props.siteData})
      this.setState({ isLoading: false });

  }




  render() {
    //create a seperate list that is sorted by id and not index in order to retain style transitions (key = id) was not enough
    let sortedPages = [...this.state.pageList];
    sortedPages.sort((a, b) => {
      return a.id > b.id ? 1 : -1;
    });


    const duplicateFunc = async (page: PageListItem,newIndex:number = -1) => {
      this.setState({ isLoading: true });

      if (page.type == PageType.Folder) {

      //find the next valid folder location
        let startIndex = this.state.pageList.indexOf(page);
        let endIndex = 0;
        for(let i = startIndex;i<this.state.pageList.length;i++){
  
          const compare = this.state.pageList[i];
          if(compare.type === PageType.AddPage){
            endIndex = i;
            break;
          }
  
        }



        await this.addPageOrFolderAtIndex(
          true,
          endIndex+1,
          false,
          this.getIndexedCopyName(page.name,page.type),
          page.isDisabled,
          page.isHidePage,
          page.isDuplicateAllLocationPage,
          (newPage: PageListItem) => {
           
            newPage.isDisabled = page.isDisabled;
            newPage.isHidePage = page.isHidePage;
            newPage.isDuplicateAllLocationPage = page.isDuplicateAllLocationPage;
            newPage.isExternalLink = page.isExternalLink;
            newPage.isExternalLinkNewTab = page.isExternalLinkNewTab;
         
            // this.saveToSiteData();
            // this.props.webDesigner.setState({siteData: this.props.siteData})
            // this.setState({pageList:list})
            this.duplicateMultiplePages(startIndex+1,endIndex,endIndex+2);
       
          },
          () => {

            
            AlertConfirm("Error Creating Folder, Please Try Again Later");
            this.setState({ isLoading: false });
            this.props.webDesigner.setState({siteData: this.props.siteData})
          },
          false,false,page.isExternalLink
        );
        return;
      }

      //create the new page
     await this.addPageOrFolderAtIndex(
        false,
        newIndex>=0?newIndex: page.index + 1,
        false,
        this.getIndexedCopyName(page.name,page.type),
        page.isDisabled,
        page.isHidePage,
        page.isDuplicateAllLocationPage,
        (newPage: PageListItem) => {
          newPage.isDisabled = page.isDisabled;
          newPage.isHidePage = page.isHidePage;
          newPage.isDuplicateAllLocationPage= page.isDuplicateAllLocationPage;
          newPage.titleTag = page.titleTag;
          newPage.metaDescription = page.metaDescription;
          newPage.openGraphImageUrl = page.openGraphImageUrl;
          newPage.isExternalLink = page.isExternalLink;
          newPage.isExternalLinkNewTab = page.isExternalLinkNewTab;

           LoadPageContentAsync(
            this.props.siteData.userContext,
            page.id,
            (data: any) => {
              let content = data.data.data.content;

              SavePageAsync(
                false,
                this.props.siteData.userContext,
                newPage.id,
                content,
                (data: any) => {
                  
                  this.props.webDesigner.tryLoadPage(newPage.id);
                  this.setState({ isLoading: false });
                  this.saveToSiteData();
                  this.props.webDesigner.setState({siteData: this.props.siteData})
                },
                (data: any) => {
                  this.setState({ isLoading: false });
                }
              );
            },
            (data: any) => {
              AlertConfirm(
                "Error Duplicating Page, Please Try Again Later"
              );
              this.setState({ isLoading: false });
            }
          );
        },
        () => {
          this.setState({ isLoading: false });
        },undefined,undefined,page.isExternalLink
      );

      this.closePageMenu();
      this.saveToSiteData();
    }
    const { IsPurchasedDomain } = store.getState().Business;

    const  UpdateFolderStatus = async (prevPageSetting:PageListItem,newPageSetting:PageListItem,closeOnSave:boolean=true)=>{

      
      const isError = {error:false};
      let hasChanged = false;
      if(prevPageSetting.isDisabled != newPageSetting.isDisabled){
        hasChanged = true;
        await DisableFolder(this.props.siteData,newPageSetting.isDisabled,prevPageSetting.id,(data)=>{

        },(data)=>{ isError.error = true;});
      }

      if(prevPageSetting.isHidePage != newPageSetting.isHidePage){
        hasChanged = true;
        await HideFolder(this.props.siteData,newPageSetting.isHidePage,prevPageSetting.id,(data)=>{

        },(data)=>{ isError.error = true;});
      }

      if(prevPageSetting.isDuplicateAllLocationPage != newPageSetting.isDuplicateAllLocationPage){
        hasChanged = true;
        await DuplicateAllLocationFolder(this.props.siteData,newPageSetting.isDuplicateAllLocationPage,prevPageSetting.id,(data)=>{

        },(data)=>{ isError.error = true;});
      }

      if(isError.error){
        AlertConfirm("Error Saving Folder, Please Try Again Later");
        
      }

      else if(hasChanged){

        let pages = this.state.pageList;
        if(pages){
          for(let i = 0;i<pages.length;i++){
            if(pages[i].folderId != prevPageSetting.id)
              continue;

            let needsUpdate = false;
            if(pages[i].isDisabled != newPageSetting.isDisabled){


              pages[i].isDisabled = newPageSetting.isDisabled;
    
              needsUpdate = true;
            }
            if(pages[i].isHidePage != newPageSetting.isHidePage){
              pages[i].isHidePage = newPageSetting.isHidePage;
              needsUpdate = true;
            }

            if(pages[i].isDuplicateAllLocationPage != newPageSetting.isDuplicateAllLocationPage){
              pages[i].isDuplicateAllLocationPage = newPageSetting.isDuplicateAllLocationPage;
              needsUpdate = true;
            }

            if(needsUpdate){
              
              const savePage = CreateSavePageObjectFromPageData(pages[i],this.props.siteData.userContext.layoutId??"",this.props.siteData.userContext.styleId??"");

              //  const savePage = {
              //   PageId: pages[i].id,
              //   LayoutId: this.props.siteData.userContext.layoutId,
              //   StyleId: this.props.siteData.userContext.styleId,
              //   PageName: pages[i].name,
              //   UrlSlug: "/" + pages[i].url,
              //   TitleTag: pages[i].titleTag,
              //   Description: pages[i].metaDescription,
              //   IsFolder: pages[i].type == PageType.Folder,
              //   FolderId: pages[i].folderId,
              //   IsDisable: pages[i].isDisabled,
              //   OpenGraphURL: pages[i].openGraphImageUrl,
              //   IsLandingPage: pages[i].isLandingPage,
              //   IsHidePage: pages[i].isHidePage,
              //   IsDuplicateAllLocationPage: pages[i].isDuplicateAllLocationPage,
              // };

              await CreateOrUpdatePage(this.props.siteData,savePage,(data)=>{
        
              },(data)=>{isError.error = true});
            }
              

          }
        }
        if(isError.error){
          AlertConfirm("Error Saving Folder, Please Try Again Later");
        }
        this.setState({pageList:[...this.state.pageList]});//updae state to reflect
      }


      if(closeOnSave)
        this.closePageMenu();
      this.saveToSiteData();
      this.setState({ isLoading: false });
      
      setTimeout(() => {
        //this.props.webDesigner.forceUpdate();
        this.props.webDesigner.setState({pageSelectKey:this.props.webDesigner.state.pageSelectKey+1})
      }, 10); 
    }

    return (
      <>
        {this.state.isLoading && <Loader />}
     
        <div>
          <PageOptionsMenu
            toggleLoading={(isLoading: boolean) => {
              this.setState({ isLoading: isLoading });
            }}
            bName={this.bName}
            tempPage={this.state.tempPage}
            siteData={this.props.siteData}
            isOpen={this.state.pageMenuOpen}
            page={this.state.editingPage}
            deletePagesFunc={this.deletePages}
            assignHomePage={this.AutoAssignHomePage}
            closeFunc={() => this.closePageMenu()}
            saveFunc={(page: PageListItem,prevPage:PageListItem,closeOnSave:boolean=true) => {

              //this.props.webDesigner.toggleLoading(true);
              const savePage = CreateSavePageObjectFromPageData(page,this.props.siteData.userContext.layoutId??"",this.props.siteData.userContext.styleId??"");
              
      

        
      
              this.setState({ isLoading: true });
              CreateOrUpdatePage(
                this.props.siteData,
                savePage,
                (data: any) => {
        
                  
                  if(savePage.PageId == this.props.webDesigner.state.currentPageId && savePage.IsDuplicateAllLocationPage!=prevPage.isDuplicateAllLocationPage){
                    let root = this.props.webDesigner.state.layout;
                    this.props.webDesigner.state.siteData.userContext.isDuplicateAllLocationPage = savePage.IsDuplicateAllLocationPage;
                    if(RestAllLocationData(this.props.webDesigner.state.layout)){
                      let temp = {...root};
                      this.props.webDesigner.setState({layout:CreateBlankLayoutNode(wBComponentTypeNames.pageRoot)});
                
                      this.props.webDesigner.setState({layout:temp});
                    }
  
                  }

                  if(page.type == PageType.Folder && 
                    (prevPage.isDisabled!=page.isDisabled||prevPage.isHidePage!=page.isHidePage||prevPage.isDuplicateAllLocationPage!=page.isDuplicateAllLocationPage)
                    ){
                    UpdateFolderStatus(prevPage,page,closeOnSave);
                  }
                  else{

                    if(closeOnSave)
                    this.closePageMenu();
                    this.saveToSiteData();
                    this.setState({ isLoading: false });
                    
                    setTimeout(() => {
                      //this.props.webDesigner.forceUpdate();
                      this.props.webDesigner.setState({pageSelectKey:this.props.webDesigner.state.pageSelectKey+1})
                    }, 10); // update the page select menu via a forced update, delay to allow page menu to animate closed
                    
                }
                },
                (data: any) => {
                  AlertConfirm("Error Saving Page, Please Try Again Later");                 
                  this.setState({ isLoading: false });
                }
              );


                

            }}
            onDeletionComplete={ async() => {
              // this.assignAllIndexes();
              this.closePageMenu();

              this.calculateNesting(null,true, false);
              await this.saveToSiteData();

       
            }}
            duplicateFunc={duplicateFunc}
            allPages={this.state.pageList}
            webDesigner={this.props.webDesigner}
          />

          <div className="flex-row justify-between">
            <h2 className="panel-heading">Pages</h2>
            <div className="flex-row" style={{ paddingRight: "8px" }}>
              <button
                className="invisible-button gray-hover small-radius"
                onClick={() => {
                  if(this.props.siteData.isModifyAllowed)
                  this.addPageOrFolderAtIndex(true, this.state.pageList.length-2)
                  else
                  AlertConfirm("You do not have permission to add folders");
                }}
              >
                <PlusFolderIcon />
                <HoverToolTip text={"Add Folder"} />
              </button>

              <button
                className="invisible-button gray-hover small-radius"
                onClick={() => {
                  
                  if(this.props.siteData.isModifyAllowed)
                  this.addPageOrFolderAtIndex(false,  this.state.pageList.length-2)
                  else
                  AlertConfirm("You do not have permission to add pages");
                
                }}
              >
                <PlusPageIcon />
                <HoverToolTip text={"Add Page"} />
              </button>

            </div>
          </div>
        </div>
        <div className="nice-scroll left-grid-content" style={{overflow:"auto",width:"100%"}}>
          <div className="page-list-container" ref={this.containerRef}>
            <ConnectDomainClickAd DomainNotPurcheshed={IsPurchasedDomain === false} designer={this.props.webDesigner}/>
            {sortedPages.map((item, index) => {
              return <this.RenderPageListItem key={item.id} item={item} />;
            })}
          </div>
        </div>
      </>
    );
  }

  

  async addPageOrFolderAtIndex(
    isFolder: boolean,
    index: number,
    shouldIndexName: boolean = true,
    name: string = "",
    isDisabled:boolean = false,
    isHidePage:boolean = false,
    isDuplicateAllLocationPage:boolean = false,
    onFinished: Function = () => {},
    onError: Function = () => {},
    saveStructure: boolean = true,
    handleLoadingSpinner:boolean = true,
    isExternalLink:boolean = false
  ) {
    let pageList = this.state.pageList;

    if(pageList.length>=maxNumberOfPages){
      AlertConfirm(
        "Maximum page limit reached, please delete unused pages and try again","max-pages-error","Maximum Page Limit"
      );
      return;
    }

    if (name == "") name = isFolder ? "New Folder" : "New Page";

    if (shouldIndexName) {
      let max = 1;
      for (let i = 0; i < this.state.pageList.length; i++) {
        let item = this.state.pageList[i];

        if (item.name.includes(name)) {
          let parse = item.name.replace(name, "");
          let num = parseInt(parse);
          if (!isNaN(num) && num >= max) max = num + 1;
        }
      }

      name += " " + max;
    }
  
    let url = name.replaceAll("(","").replaceAll(")","").replaceAll(" ", "-").toLowerCase();
    
    if(isExternalLink){

   
      url = "https://www.vagaro.com";
      
      // while(num<1000 && pageList.find((x)=>x.url==root+num.toString()+".com")){
      //   num++;
      // }
    
      // url = root+num.toString()+".com";
    }

    let newItem: PageListItem = {
      type: isFolder ? PageType.Folder : PageType.Page,
      name: name,
      url: url,
      index: index,
      folderName: "",
      folderId: "",
      isNested: false,
      isDisabled: isDisabled,
      isExternalLink:isExternalLink,
      titleTag: getFormattedTitleTag(name,this.bName),
      metaDescription: "",
      openGraphImageUrl: "",
      id: "",
      isLandingPage: false,
      isHidePage: isHidePage,
      isDuplicateAllLocationPage:isDuplicateAllLocationPage
    };

    const savePage = CreateSavePageObjectFromPageData(newItem,this.props.siteData.userContext.layoutId??"",this.props.siteData.userContext.styleId??"");
    // const savePage = {
    //   PageId: "",
    //   LayoutId: this.props.siteData.userContext.layoutId,
    //   StyleId: this.props.siteData.userContext.styleId,
    //   PageName: newItem.name,
    //   UrlSlug: "/" + newItem.url,
    //   TitleTag: newItem.titleTag,
    //   Description: newItem.metaDescription,
    //   IsFolder: isFolder,
    //   FolderId: newItem.folderId,
    //   OpenGraphURL: newItem.openGraphImageUrl,
    //   PageOrder: -1,
    //   IsDisabled: newItem.isDisabled,
    //   isLandingPage: newItem.isLandingPage,
    //   isHidePage: newItem.isHidePage,
    //   isDuplicateAllLocationPage:newItem.isDuplicateAllLocationPage
    // };

    const onComplete = async (data: any) => {
      if (data.data.data.pageId) {
        newItem.id = data.data.data.pageId;

        pageList.splice(index, 0, newItem);
        if (newItem.type == PageType.Folder)
          pageList.splice(index + 1, 0, {
            ...newItem,
            type: PageType.AddPage,
            name: "Add Page",
            id: CreateNewGUID(),
          });

        this.calculateNesting(pageList,false);
        this.setState({ pageList: pageList });
        this.calculateNesting(pageList,true);
        if (saveStructure) await this.saveToSiteData(pageList);

        if(handleLoadingSpinner)
        this.setState({ isLoading: false });
        onFinished(newItem);

        
        this.openPageMenu(newItem);

        if(!isExternalLink){
          if (this.props.siteData.pages.length == 1) {
            this.props.webDesigner.tryLoadPage(newItem.id);
          }
          else{
            this.props.webDesigner.setState({siteData: this.props.siteData})
            this.props.webDesigner.tryLoadPage(newItem.id);
          }
        }


      } else {
        AlertConfirm(
          "Please refresh page and try again.",
          "create-page-error",
          "Page Error"
        );
        onError();
        if(handleLoadingSpinner)
        this.setState({ isLoading: false });
      }
    };

    if(handleLoadingSpinner)
    this.setState({ isLoading: true });
    await CreateOrUpdatePage(
      this.props.siteData,

      savePage,
      onComplete,
      (data: any) => {
        const pOrF = isFolder ? "Folder" : "Page";
        AlertConfirm(
          `Error Creating ${pOrF}, Please Try Again Later`,
          "creation-error",
          `${pOrF} Error`
        );
        if(handleLoadingSpinner)
        this.setState({ isLoading: false });
      }
    );
  }

  reloadPages() {
    this.setState({ isLoading: true });
    getAllPagesContentless(
      this.props.siteData.userContext,
      (data) => {
        this.props.siteData.pages = CreatePageDataFromAPI(
          data,
          this.props.siteData
        );
        this.setState({ isLoading: false });
        this.setState({ pageList: CompilePageList(this.props.siteData.pages) });
      },
      () => {
        AlertConfirm(
          "Error Loading Website Pages, Please Try Again Later",
          "page-load-error",
          "Issue Loading Page"
        );

        this.setState({ isLoading: false });
      }
    );
  }

  endDrag() {

 

    if (!this.state.draggedPage) return;



    let newIndex = this.calcNewIndex();

    if(!this.props.siteData.isModifyAllowed){
      AlertConfirm("You do not have permission to modify page order");
     
    }

    let pages = this.state.pageList;
    let dpage = this.state.draggedPage;
    if(this.props.siteData.isModifyAllowed){
      pages.splice(dpage.index, 1);
      pages.splice(newIndex, 0, dpage);
    }

    if (this.state.draggedPage.type == PageType.Folder) {
      this.expandAllFolders();
    }

    this.assignAllIndexes();
    this.setState({ draggedPage: null, dragState: DragState.none });
    this.calculateNesting(pages,true);

    if(this.props.siteData.isModifyAllowed)
      this.saveToSiteData();
  }

  async saveToSiteData( pageList:PageListItem[]|null = null) {

      if(!this.props.siteData.isModifyAllowed)
        return;


    if(pageList==null)
      pageList = this.state.pageList;
      savePageListToSiteData(this.state.pageList, this.props.siteData, () => {
      //this.setState({ pageList: CompilePageList(this.props.siteData.pages) });
    });

    //query all navigation list items and force update them to display new page layout
    let navList = document.querySelectorAll(".v-navigation-bar");
    for (let i = 0; i < navList.length; i++) {
      let id = navList[i].id;
      let layoutNode = this.props.webDesigner.layoutNodeDictionary[id];
      if(layoutNode&&layoutNode.forceUpdate)
        layoutNode.forceUpdate();


    }

    await SavePageStructure(
      this.props.siteData,
      (data: any) => {},
      (data: any) => {
        AlertConfirm(
          "Error Saving Page Structure, Please Try Again Later",
          "page-structure-error",
          "Page Structure Error"
        );
      }
    );
  }

  handleTouchMove(e: TouchEvent) {
    if (this.state.draggedPage) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  handleMouseMove(e: PointerEvent) {
    if (this.state.draggedPage && this.containerRef.current) {
      this.setYPos(e.clientY);

      if (this.state.dragState == DragState.preDrag) {
        let mouseDistance = Math.abs(this.mouseDownPosition - e.clientY);
        if (mouseDistance > 6) {
          this.hasDragged = true;
          if (this.state.draggedPage.type == PageType.Folder)
            this.collapseAllFolders();
          this.setState({ dragState: DragState.dragging });
        }
      } else if (this.state.dragState == DragState.dragging) {
        this.handleDrag();
      }
    }
  }

  handleDrag() {
    if (this.state.draggedPage) {
      let dpage = this.state.draggedPage;
      let pages = this.state.pageList;
      let realIndex = this.state.pageList.indexOf(dpage);
      let newIndex = this.calcNewIndex();
      pages.splice(realIndex, 1);
      pages.splice(newIndex, 0, dpage);
      this.assignAllIndexes();
      if (this.state.draggedPage.type != PageType.Folder)
        this.calculateNesting();
    }
  }

  calcNewIndex() {
    const draggedItem = this.state.draggedPage;
    if (!draggedItem) return -1;

    let height = 0;
    let newI = 0;

    for(let i = 0; i < this.state.pageList.length; i++){
      height += pageHeight;
      if(height > this.state.mouseY){
        newI = i;
        break;
      }
    
 
      if(this.state.pageList[i].type == PageType.AddFolder)
        height += pageHeight;
    }
    
    let newIndex = newI;//Math.floor(this.state.mouseY / pageHeight);
    if (newIndex < 0) newIndex = 0;

    if (newIndex >= this.state.pageList.length - 2)
      newIndex = this.state.pageList.length - 3; //-3 to account for the add page and add folder items

    return newIndex;
  }

  async calculateNesting(pageList:PageListItem[]|null = null, updateAndSaveFolderInfo = false, updateButDontSave = false) {
    if(pageList==null) pageList= this.state.pageList;
    let lastFolderId = "";
    let lastFolderName = "";
    let inFolder = false;



    for (let i = 0; i < pageList.length; i++) {
      // account for the add page and add folder items

      let item = pageList[i];
      item.index = i;

      item.isNested =
        inFolder && item.type != PageType.Folder && i < pageList.length - 2;

      if (
        item.type == PageType.Page &&
        item.folderId != lastFolderId &&
        updateAndSaveFolderInfo
      ) {
        item.folderName = lastFolderName;
        item.folderId = lastFolderId;

        if (!updateButDontSave){
//eslint-disable-next-line
          let folderItem = this.state.pageList.find((x) => x.id == lastFolderId);
          let needsUpdate = false;
          if(folderItem?.isDisabled && !item.isDisabled){

            if(!item.isExternalLink)
            item.isDisabled = true;
            needsUpdate = true;
          }
          else if(folderItem?.isHidePage){
            if(!item.isDisabled && !item.isHidePage&&!item.isExternalLink){
              item.isHidePage = true;
              needsUpdate = true;
            }
          }
          if(folderItem?.isDuplicateAllLocationPage){
            if(!item.isDuplicateAllLocationPage&&!item.isExternalLink){
              item.isDuplicateAllLocationPage = true;
              needsUpdate = true;
            }
          }
          
          if(needsUpdate){


            this.setState({pageList:[...this.state.pageList]});
          }

       let saveP =   CreateSavePageObjectFromPageData(item,this.props.siteData.userContext.layoutId??"",this.props.siteData.userContext.styleId??"");
        await  CreateOrUpdatePage(
            this.props.siteData,
            saveP,
            (data: any) => {},
            (data: any) => {}
          );
      

        }
      } else if (
        item.type == PageType.Folder &&
        item != this.state.draggedPage
      ) {
        inFolder = true;
        lastFolderId = item.id;
        lastFolderName = item.name;
      } else if (item.type == PageType.AddPage) {
        inFolder = false;
        lastFolderId = "";
        lastFolderName = "";
      }
    }
  }

  setYPos(inY: number) {
    if (this.containerRef.current) {
      let top = inY - this.containerRef.current.getBoundingClientRect().top;

      this.setState({ mouseY: top });
    }
  }

  startClick(e: React.PointerEvent<HTMLDivElement>, item: PageListItem) {
    if (this.state.pageMenuOpen) this.openPageMenu(item);

    this.hasDragged = false;
    this.mouseDownPosition = e.clientY;
    this.originalIndex = item.index;
    this.setYPos(e.clientY);
    if(this.props.siteData.isModifyAllowed)
    this.setState({ draggedPage: item, dragState: DragState.preDrag });
  }

  collapseAllFolders() {
    let currentFolder = null;

    let pageList = this.state.pageList;

    for (let i = 0; i < pageList.length; i++) {
      let item = pageList[i];
      if (item.type == PageType.Folder) {
        currentFolder = item;
      } else if (
        (item.type == PageType.Page || item.type == PageType.AddPage) &&
        currentFolder
      ) {
        if (currentFolder.folderContents == null) {
          currentFolder.folderContents = [item];
        } else {
          currentFolder.folderContents.push(item);
        }

        pageList.splice(i, 1);
        i--;

        if (item.type == PageType.AddPage) {
          currentFolder = null;
        }
      }
    }
  }

  assignAllIndexes() {
    let pageList = this.state.pageList;

    for (let i = 0; i < pageList.length; i++) {
      let page = pageList[i];
      page.index = i;
    }
  }

  expandAllFolders() {
    let pages = this.state.pageList;

    for (let i = 0; i < pages.length; i++) {
      let item = pages[i];
      if (item.type == PageType.Folder) {
        if (item.folderContents) {
          pages.splice(i + 1, 0, ...item.folderContents);
          i += item.folderContents.length;
          item.folderContents = null;
        }
      }
    }
  }

  
  async AutoAssignHomePage(
    saveFunc:Function,
    ingoreId: string,
    ignoreIfHompageValid: boolean = false
  ) {
  
    let allPages = this.state.pageList;
    let webDesigner = this.props.webDesigner;
    let siteData = this.props.siteData;
    if (ignoreIfHompageValid) {
      for (let i = 0; i < allPages.length; i++) {
        if (allPages[i].id == webDesigner.props.siteData.homePageId)
          return false;
      }
    }

    let id = webDesigner.props.siteData.homePageId;

    for (let i = 0; i < allPages.length; i++) {
      if (
        allPages[i].type == PageType.Page &&
        allPages[i].id != ingoreId &&
        allPages[i].id != id &&
        !allPages[i].isDisabled
      ) {
        webDesigner.props.siteData.homePageId = allPages[i].id;
        //this.calculateNesting();
   

        allPages[i].isLandingPage = true;
        this.calculateNesting(allPages);
        this.saveToSiteData(allPages);

        
        saveFunc(allPages[i],false);

       if(this.props.webDesigner.saveType==SaveType.All||this.props.webDesigner.saveType==SaveType.Style) 
         await SaveSiteStyle(siteData, () => {  }, () => { });
       this.setState({pageList:allPages});
        return true;
      }
    }

    return false;
  };

  RenderPageListItem({ item }: { item: PageListItem }) {


    let height = 0;
    for(let i = 0; i < this.state.pageList.length; i++){
   
      if(this.state.pageList[i].id == item.id)
        break;
      height += pageHeight;
      if(this.state.pageList[i].type == PageType.AddFolder)
        height += pageHeight;
    }
    const nestedClass = item.isNested ? " nested" : "";
    let style: {} =
      item == this.state.draggedPage &&
      this.state.dragState == DragState.dragging
        ? {
            top: this.state.mouseY - pageHeight / 2 + "px",
            zIndex: 100,
            backgroundColor: "#eee",
            transition: "none",
            cursor: "grabbing !important",
          }
        : { top: height + "px" };

    if (
      this.state.draggedPage &&
      this.state.dragState == DragState.dragging &&
      this.state.draggedPage.type == PageType.Folder &&
      item.isNested
    ) {
      style = { ...style, display: "none" };
    }
    const selectedClass = this.state.editingPage == item ? " selected" : "";
    const disabled = item.isDisabled ? " disabled" : "";
    const duplicated = item.isDuplicateAllLocationPage ? " duplicated" : "";
    const hide = item.isHidePage ? " hide" : "";

    const isCurrent =
      this.props.webDesigner.state.currentPageId == item.id ? " current" : "";
    switch (item.type) {
      case PageType.Folder:
        return (
          <div
            style={style}
            id={item.id}
            key={item.id}
            onClick={(e) => {
              if (this.state.pageMenuOpen) {
               this.tryChangePage(item)
              }
            }}
            className={
              "page-folder-item folder" + nestedClass + selectedClass + disabled + hide + duplicated
            }
          >
            <DragHandle
              item={item}
              dragStart={this.startClick}
              dragging={this.state.draggedPage != null}
            />
            <FolderIcon isDuplicate={item.isDuplicateAllLocationPage} />
            <span>{item.name}</span>
            {this.state.dragState != DragState.dragging && (
              <button
                onClick={(e) => {

                  if(this.state.editingPage == item)
                    this.tryChangePage(null);
                  else
                    this.tryChangePage(item)
                  e.preventDefault();
                  e.stopPropagation();
                }}
                className="page-settings-button invisible-button"
              >
                <LightGearIcon />
              </button>
            )}
          </div>
        );
      case PageType.Page:
        const homeIcon =
          item.id == this.props.siteData.homePageId ? (
            <HomeHeartIcon />
          ) :
          
          item.isExternalLink?<svg xmlns="http://www.w3.org/2000/svg" width={".8em"} fill="currentColor" viewBox="0 0 512 512"><path d="M326.6 185.4c59.7 59.8 58.9 155.7 .4 214.6-.1 .1-.2 .3-.4 .4l-67.2 67.2c-59.3 59.3-155.7 59.3-215 0-59.3-59.3-59.3-155.7 0-215l37.1-37.1c9.8-9.8 26.8-3.3 27.3 10.6 .6 17.7 3.8 35.5 9.7 52.7 2 5.8 .6 12.3-3.8 16.6l-13.1 13.1c-28 28-28.9 73.7-1.2 102 28 28.6 74.1 28.7 102.3 .5l67.2-67.2c28.2-28.2 28.1-73.8 0-101.8-3.7-3.7-7.4-6.6-10.3-8.6a16 16 0 0 1 -6.9-12.6c-.4-10.6 3.3-21.5 11.7-29.8l21.1-21.1c5.5-5.5 14.2-6.2 20.6-1.7a152.5 152.5 0 0 1 20.5 17.2zM467.5 44.4c-59.3-59.3-155.7-59.3-215 0l-67.2 67.2c-.1 .1-.3 .3-.4 .4-58.6 58.9-59.4 154.8 .4 214.6a152.5 152.5 0 0 0 20.5 17.2c6.4 4.5 15.1 3.8 20.6-1.7l21.1-21.1c8.4-8.4 12.1-19.2 11.7-29.8a16 16 0 0 0 -6.9-12.6c-2.9-2-6.6-4.9-10.3-8.6-28.1-28.1-28.2-73.6 0-101.8l67.2-67.2c28.2-28.2 74.3-28.1 102.3 .5 27.8 28.3 26.9 73.9-1.2 102l-13.1 13.1c-4.4 4.4-5.8 10.8-3.8 16.6 5.9 17.2 9 35 9.7 52.7 .5 13.9 17.5 20.4 27.3 10.6l37.1-37.1c59.3-59.3 59.3-155.7 0-215z"/></svg>:
          (
            <PageIcon isDuplicate={item.isDuplicateAllLocationPage} />
          );

        return (
          <div
            key={item.id}
            id={item.id}
            style={style}
            className={
              "page-folder-item" +
              nestedClass +
              selectedClass +
              disabled +
              isCurrent + hide + duplicated
            }
            onClick={(e) => {
            
              if (
                (this.props.siteData.currentPageId != item.id &&
                !this.state.pageMenuOpen &&!item.isExternalLink)
              ) {
                this.props.webDesigner.trySwitchPage(item.id);
              } else {
               this.tryChangePage(item)
              }
            }}
          >
            <DragHandle
              item={item}
              dragStart={this.startClick}
              dragging={this.state.draggedPage != null}
            />
            {homeIcon}

            <span>{item.name}</span>
            {this.state.dragState != DragState.dragging && (
              <button
                onClick={(e) => {
    

                  if(this.state.pageMenuOpen && this.state.editingPage?.id == item.id){
                    this.tryChangePage(null);
                    e.preventDefault();
                    e.stopPropagation();
                
                  }
                  else {
                    this.tryChangePage(item);
                    e.preventDefault();
                    e.stopPropagation();
                  }
               
         
            
                }}
                className="page-settings-button invisible-button"
              >
                <LightGearIcon />
              </button>
            )}
          </div>
        );
      case PageType.AddPage:
        return (
          <div
            style={{ ...style, background: "white", position: "absolute", transition: ".2s" }}
            className="w-full"

            id={item.id}
            key={item.id}
          >
            <div className="flex-column h-full" >
              <div style={{ position: "relative" }} className={"page-folder-item add" + nestedClass}
                onClick={() => {
                  if (this.props.siteData.isModifyAllowed)
                    this.addPageOrFolderAtIndex(false, item.index);
                  else
                    AlertConfirm("You do not have permission to add pages");

                }}

              >
                <PlusIcon />
                <span>Add Page</span>
              </div>
            </div>
          </div>
        );
      case PageType.AddFolder:
        return (


          <div
            style={{ ...style, height: pageHeight * 2 + "px", background: "white", position: "absolute", transition: ".2s" }}
            className="w-full"

            id={item.id}
            key={item.id}
          >
            {<div style={{ position: "relative" }} className={"page-folder-item add" + nestedClass}

              onClick={() => {
                if (this.props.siteData.isModifyAllowed)
                  this.addPageOrFolderAtIndex(false, item.index - 1, true, "New Link", false, false, false, undefined, undefined, true, true, true);
                else
                  AlertConfirm("You do not have permission to add links");

              }}


            >
              <PlusIcon />
              <span>Add Nav Link</span>
            </div>}
            <div className="flex-column h-full" >
              <div style={{ position: "relative" }} className={"page-folder-item add" + nestedClass}
                onClick={() => {
                  if (this.props.siteData.isModifyAllowed)
                    this.addPageOrFolderAtIndex(true, item.index - 1);
                  else
                    AlertConfirm("You do not have permission to add folders");

                }}

              >
                <PlusIcon />
                <span>Add Folder</span>
              </div>

            </div>
          </div>



        );

      default:
        return null;
    }
  }

  openPageMenu(item: PageListItem) {
   


    this.setState({ pageMenuOpen: true, editingPage: item, tempPage: {...item,id:"temp"} });
    setTimeout(() => {

      let inpt = document.getElementById("page-name-input");
      if(inpt){
        inpt.focus();
       (inpt as any).select();
       
      }

    },0)

  }

  closePageMenu() {

    this.setState({ pageMenuOpen: false, editingPage: null,tempPage:null });
  }
}



function PageIcon({isDuplicate}:{isDuplicate?:boolean}) {

  if(isDuplicate)
  return <svg xmlns="http://www.w3.org/2000/svg"    fill="currentColor" viewBox="0 0 448 512"><path d="M160 368H384c8.8 0 16-7.2 16-16V128H352c-17.7 0-32-14.3-32-32V48H160c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16zm224 48H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64H325.5c17 0 33.3 6.7 45.3 18.7l58.5 58.5c12 12 18.7 28.3 18.7 45.3V352c0 35.3-28.7 64-64 64zM24 96c13.3 0 24 10.7 24 24V376c0 48.6 39.4 88 88 88H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V120c0-13.3 10.7-24 24-24z"/></svg>

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 512"
      fill="currentColor"
    >
      <path d="M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z" />
    </svg>
  );
}

function FolderIcon({isDuplicate}:{isDuplicate?:boolean}) {

if(isDuplicate)
return <svg xmlns="http://www.w3.org/2000/svg"    fill="currentColor" viewBox="0 0 576 512"><path d="M512 336H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H277.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H512c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16zM160 384H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H394.5c-17 0-33.3-6.7-45.3-18.7L322.7 50.7c-12-12-28.3-18.7-45.3-18.7H160c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"/></svg>

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="currentColor"
    >
      <path d="M0 96C0 60.7 28.7 32 64 32H196.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7H64z" />
    </svg>
  );
}


function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      fill="currentColor"
    >
      <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
    </svg>
  );
}

function DragHandle({
  item,
  dragStart,
  dragging,
}: {
  item: PageListItem;
  dragStart: Function;
  dragging: boolean;
}) {
  return (
    <div
      className={"page-grab-icon " + (dragging ? "dragged" : "")}
      onPointerDown={(e) => dragStart(e, item)}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <HamburgerIcon />
    </div>
  );
}

function CompilePageList(pageData: PageData[]) {
  let pageList: PageListItem[] = [];

  let index = 0;

  for (let i = 0; i < pageData.length; i++) {
    const data = pageData[i];

    if (data.isFolder) {
      // folder add the folder and all its children
      pageList.push({
        type: PageType.Folder,
        name: data.name,
        url: data.url,
        index: index,
        isNested: false,
        
        id: data.pageId,
        isDisabled: data.isDisabled,
        titleTag: "",
        folderName: "",
        folderId: "",
        metaDescription: "",
        openGraphImageUrl: "",
        isLandingPage: data.isLandingPage,
        isHidePage: data.isHidePage,
        isDuplicateAllLocationPage:data.isDuplicateAllLocationPage
      });

      index++;
      if (data.children)
        for (let e = 0; e < data.children.length; e++) {
          // all its children
          let child = data.children[e];
          pageList.push({
            type: PageType.Page,
            name: child.name,
            url: child.url,
            index: index,
            isNested: true,
            isExternalLink:child.isExternalLink ,
            isExternalLinkNewTab:child.isExternalLinkNewTab,
            folderName: child.name,
            folderId: typeof child.folderId!="undefined" && child.folderId!=null && child.folderId!="" ? child.folderId : "",
            id: child.pageId,
            isDisabled: child.isDisabled,
            titleTag: typeof child.titleTag!="undefined" && child.titleTag!=null && child.titleTag!="" ? child.titleTag : "",
            metaDescription: typeof child.metaDescription!="undefined" && child.metaDescription!=null && child.metaDescription!="" ? child.metaDescription : "",
            openGraphImageUrl: typeof child.openGraphImageUrl!="undefined" && child.openGraphImageUrl!=null && child.openGraphImageUrl!="" ? child.openGraphImageUrl : "",
            isLandingPage: child.isLandingPage,
            isHidePage: child.isHidePage,
            isDuplicateAllLocationPage:child.isDuplicateAllLocationPage
          });
          index++;
        }
      pageList.push({
        // add page button at bottom of folder
        type: PageType.AddPage,
        name: "Add Page",
        url: "",
        index: index,
        folderName: "",
        folderId: "",
        isNested: true,
        id: CreateNewGUID(),
        isDisabled: false,
        titleTag: "",
        metaDescription: "",
        openGraphImageUrl: "",
        isLandingPage: false,
        isHidePage:false,
        isDuplicateAllLocationPage:false
      });
      index++;
    } else {
      //single page simply add to root
      pageList.push({
        type: PageType.Page,
        name: data.name,
        url: data.url,
        index: index,
        folderName: "",
        folderId: "",
        isExternalLink:data.isExternalLink,
        isExternalLinkNewTab:data.isExternalLinkNewTab,
        isNested: false,
        id: data.pageId,
        isDisabled: data.isDisabled,
        titleTag: data.titleTag,
        metaDescription: data.metaDescription,
        openGraphImageUrl: data.openGraphImageUrl,
        isLandingPage: data.isLandingPage,
        isHidePage: data.isHidePage,
        isDuplicateAllLocationPage:data.isDuplicateAllLocationPage
      });
      index++;
    }
  }
  pageList.push({
    //add the two buttons at the bottom
    type: PageType.AddPage,
    name: "Add Page",
    folderName: "",
    folderId: "",
    url: "",
    index: index,
    isNested: false,
    id: CreateNewGUID(),
    isDisabled: false,
    titleTag: "",
    metaDescription: "",
    openGraphImageUrl: "",
    isLandingPage: false,
    isHidePage: false,
    isDuplicateAllLocationPage:false
  });
  pageList.push({
    type: PageType.AddFolder,
    name: "Add Folder",
    folderName: "",
    folderId: "",
    url: "",
    index: index + 1,
    isNested: false,
    id: CreateNewGUID(),
    isDisabled: false,
    titleTag: "",
    metaDescription: "",
    openGraphImageUrl: "",
    isLandingPage: false,
    isHidePage: false,
    isDuplicateAllLocationPage:false
  });

  return pageList;
}

function savePageListToSiteData(
  pageList: PageListItem[],
  siteData: SiteData,
  onComplete?: Function
) {
  let newPageData: PageData[] = [];
  let lastFolder: PageData | null = null;

  for (let i = 0; i < pageList.length; i++) {
    let page = pageList[i];
    if (page.type == PageType.Page || page.type == PageType.Folder) {
      let newPage: PageData = {
        pageId: page.id,
        name: page.name,
        url: page.url,
        children: [],
        isFolder: page.type == PageType.Folder,
        folderId: page.folderId,
        metaDescription: page.metaDescription,
        titleTag: page.titleTag,
        isDisabled: page.isDisabled,
        isLandingPage: page.isLandingPage,
        openGraphImageUrl: page.openGraphImageUrl,
        isHidePage: page.isHidePage,
        isExternalLink:page.isExternalLink,
        isExternalLinkNewTab:page.isExternalLinkNewTab,
        
        isDuplicateAllLocationPage:page.isDuplicateAllLocationPage
      };

      if (!page.isNested)
        //non nested
        newPageData.push(newPage);
      else if (lastFolder != null) {
        // nested
        if (!lastFolder.children) lastFolder.children = [newPage];
        else lastFolder.children.push(newPage);
      }

      if (page.type == PageType.Folder) lastFolder = newPage;
    }
  }

  siteData.pages = newPageData;
  siteData.userContext.pages = newPageData;
  if (onComplete) onComplete();
}

function formatURLString(val: string) {
  return val
    .replaceAll(" ", "-")
    .toLowerCase()
    .replace(/[^a-zA-Z0-9-]/g, "");
}



function PageOptionsMenu({
  isOpen,
  page,
  closeFunc,
  saveFunc,
  allPages,
onDeletionComplete,
  duplicateFunc,
  assignHomePage,
  webDesigner,
  siteData,
  toggleLoading,
  tempPage,
  deletePagesFunc,
  bName
}: {
  allPages: PageListItem[];
  isOpen: boolean;
  page: PageListItem | null;
  closeFunc: Function;
  saveFunc: (page:PageListItem,prevPageState:PageListItem,close:boolean) => void;
  duplicateFunc: Function;
  assignHomePage:Function;
  onDeletionComplete: Function;
  deletePagesFunc:Function
  webDesigner: WebDesigner;
  siteData: SiteData;
  toggleLoading: Function;
  tempPage:PageListItem | null;
  bName:string;
}) {
  const mainStyle = {
    position: "absolute",
    textAlign: "left",
    top: "0px",
    left: "0",
    height: "100%",
    backgroundColor: "white",
    transition: ".4s",
    zIndex: 147,
    overflow: "auto",
    whiteSpace: "nowrap",
    padding: "16px 0px",
    boxShadow: "16px -1px 20px -4px #00000030",
  };
  const style = isOpen
    ? { ...mainStyle, width: "800px", padding: "16px 16px" }
    : { ...mainStyle, width: "0px" };

  const [nameValidation, setNameValidation] = useState<string>("");
  const [urlValidation, setURLValidation] = useState<string>("");
  const [prevPage, setPreviousPage] = useState<PageListItem | null>(page);
  const nameInput = useRef<HTMLInputElement>(null);

  const [prevNameInput, setPreviousName] = useState<string>(page?.name ?? "");
  const slugInput = useRef<HTMLInputElement>(null);
  const [newOpenGraph,setNewOpenGraph] = useState<string>(page?.openGraphImageUrl ?? "");
  const titleTagInput = useRef<HTMLInputElement>(null);
  const metaDescInput = useRef<HTMLTextAreaElement>(null);
  const diablePageInput = useRef<HTMLInputElement>(null);
  const hidePageInput = useRef<HTMLInputElement>(null);
  const isDuplicateAllLocationPageInput = useRef<HTMLInputElement>(null);


  const landingPageInput = useRef<HTMLInputElement>(null);
  const newTabInput = useRef<HTMLInputElement>(null);
  const mainPage = useRef<HTMLDivElement>(null);

  const centerGrid = document.querySelector(".grid-center");

  let rootURL =  siteData.vagaroURL? "https://"+siteData.vagaroURL+"/": "https://yourdomain.com/";


  const folderOrPage =
    page != null && page.type == PageType.Folder ? "Folder" : page?.isExternalLink?"Link":"Page";

  useEffect(() => {
    assignHomePage(saveFunc,"", true);

    if (page != prevPage) {
      setPreviousPage(page);
      setNameValidation("");
      setURLValidation("");
      setNewOpenGraph(page?.openGraphImageUrl ?? "");
      setPreviousName(page?.name ?? "");
      if(tempPage){
        tempPage.name = page?.name ?? "";
        tempPage.url = page?.url ?? "";
        tempPage.titleTag = page?.titleTag ?? "";
        tempPage.metaDescription = page?.metaDescription ?? "";
        tempPage.openGraphImageUrl = page?.openGraphImageUrl ?? "";
        tempPage.isDisabled = page?.isDisabled ?? false;
        tempPage.isLandingPage = page?.isLandingPage ?? false;
        tempPage.isExternalLinkNewTab = page?.isExternalLinkNewTab ?? false;
        
      }

    }
//eslint-disable-next-line
  },[page]);

  const savePageData = () => {

    const clonePage =  (page)?{...page}:null;
    if (
      page != null &&
      nameInput.current &&
      (diablePageInput.current ||page.isExternalLink)&&
      (landingPageInput.current || page.type == PageType.Folder||page.isExternalLink)
    ) {


    
      let name = nameInput.current.value.trim();
      page.openGraphImageUrl = newOpenGraph;
      let url = slugInput.current ? slugInput.current.value : "";
      if(page.isExternalLink)
        url = url;
      page.name = name;
      if(!page.isExternalLink)
        url = formatURLString(url);
   
      page.url = url;

  


      if (titleTagInput.current) page.titleTag = titleTagInput.current.value;
      if (metaDescInput.current) page.metaDescription = metaDescInput.current.value;

      const isLandingPage = landingPageInput.current?.checked ?? false;

      //landing page can't be disabled
      if (diablePageInput.current) page.isDisabled = diablePageInput.current.checked&&!isLandingPage;

      if (hidePageInput.current) page.isHidePage = hidePageInput.current.checked;

      if (isDuplicateAllLocationPageInput.current) page.isDuplicateAllLocationPage = isDuplicateAllLocationPageInput.current.checked;

      if (landingPageInput.current)page.isLandingPage = isLandingPage;

      if (newTabInput.current && page.isExternalLink)page.isExternalLinkNewTab = newTabInput.current.checked;

    }




    if(page&&clonePage)
      saveFunc(page,clonePage,true);
  };

  const validateURLAndName = () => {
    if (!page) return;

    const nameVal = nameInput.current?.value?.trim() ?? "";
    const urlVal = slugInput.current?.value?.trim() ?? "";
    let nameValidation = "";
    let urlValidation = "";

    //check for duplicates
    for (let i = 0; i < allPages.length; i++) {
      let compPage = allPages[i];
      if (compPage == page) continue;

      if (
        nameInput.current &&
        compPage.name == nameVal &&
        compPage.type == page.type
      ) {
        nameValidation = folderOrPage + " name already exists";
      }

      if (slugInput.current && compPage.url === urlVal && !compPage.isExternalLink && !page.isExternalLink) {
        urlValidation = "URL slug already exists";
      }

      

    }


    const slugIndex:number = ReservedURLSlugs.indexOf(urlVal);

        //check for empty strings or special cases
    if (nameInput.current && nameVal.trim().length == 0) {
      nameValidation = "Please enter " + folderOrPage.toLowerCase() + " name";
    }

    if(page.isExternalLink){
      const urlRegex = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]{2,}(:\d+)?(\/[^\s]*)?$/;
      if(! urlRegex.test(urlVal)){
        urlValidation = "Please enter valid URL";
      }
    }

    if (slugInput.current && urlVal.trim().length == 0) {
      urlValidation = "Please enter URL slug";
    }
    else if(slugInput.current && slugIndex>=0)
      urlValidation = `'${ReservedURLSlugs[slugIndex]}' is a resevered URL slug and cannot be used`;
      setNameValidation(nameValidation);
      setURLValidation(urlValidation);
  };

  const UpdateInputAndPreview = (e: any, target: string) => {
    if (!e.target) return;

    const eTarget = e.target as HTMLInputElement;
    let docTarget = target == "name" ? "title" : target;
    let newVal = eTarget.value;
    if (target === "url") {
      newVal = formatURLString(newVal);
      eTarget.value = newVal;
      newVal = rootURL + newVal;
    }
    else if(target == "external-link"){
      newVal = eTarget.value;
      
      newVal = newVal.trimStart().replaceAll(" ","-");

      if(newVal.length>0&&!newVal.startsWith("http") && !("http").includes(newVal)){
        newVal = "https://"+newVal;
      }
      // if(newVal.startsWith("https://"))
      //   newVal = newVal.substring(8);
      // else if(newVal.startsWith("http://"))
      //   newVal = newVal.substring(7);
      eTarget.value = newVal;


    }
    let changeElem = document.getElementById("search-preview-" + docTarget);
  
    if (target == "title" ||target=="name") {
      newVal = titleTagInput.current?.value ?? bName;
    } 


    if (changeElem) changeElem.textContent = newVal;

    

    if(tempPage){
      tempPage.name = nameInput.current?.value ?? "";
      tempPage.url = slugInput.current?.value ?? "";
      tempPage.titleTag = titleTagInput.current?.value ?? "";
      tempPage.metaDescription = metaDescInput.current?.value ?? "";
      tempPage.openGraphImageUrl = newOpenGraph;
      tempPage.isDisabled = diablePageInput.current?.checked ?? false;
      tempPage.isLandingPage = landingPageInput.current?.checked ?? false;

    }
  
   
    validateURLAndName();
 
  };

  const updateNameInput = (page:PageListItem,e: any, pageOrFolder: string) => {
    let prev = prevNameInput.toLowerCase();
    prev = formatURLString(prev);
    let newName = e.target.value.trim();

  

    if (slugInput.current && !page.isExternalLink) {
      if (slugInput.current.value == prev) {
        slugInput.current.value = formatURLString(newName);
      }
    }
    if(titleTagInput.current){
   
      let tag = titleTagInput.current.value;
      let compare = getFormattedTitleTag(prevNameInput,bName);
      if(tag == compare||tag==""||tag==bName){
       
        titleTagInput.current.value = getFormattedTitleTag(newName,bName);
      }

    }

    if(tempPage)
      tempPage.name = newName;

    setPreviousName(newName);
    validateURLAndName();

  };

  const tryDelete = (page:PageListItem) => {
   
    if (page.type == PageType.Page) {
let pgName = page.isExternalLink?"link":"page";
      
      DestructiveConfirmation(
        `This ${pgName} will be permanently deleted from your website.`,
        ()=>deletePagesFunc([page],()=>{onDeletionComplete();assignHomePage(saveFunc,"",true);}),
        () => {},
        "delete-page-confirm",
        `Delete ${pgName}`,
        `Delete ${pgName}`
      );
    } else {
      DestructiveConfirmation(
        `This folder will be permanently deleted from your website, and any pages within the folder also be deleted.`,
        ()=>{

          let pages = [];
          pages.push(page);

          for (let i = page.index + 1; i < allPages.length; i++) {
            if(allPages[i].type == PageType.Page && allPages[i].isNested ){
              pages.push(allPages[i]);
            }
            else if(allPages[i].type==PageType.AddPage){
              pages.push(allPages[i]);
              break;
            }
            else
              break;

          }

          deletePagesFunc(pages,()=>{onDeletionComplete();assignHomePage(saveFunc,"",true);})

        },
        () => {},
        "delete-page-confirm",
        `Delete folder`,
        `Delete folder`
      );
      }
    }


  const UploadGraphImage = (filename: string, Base64: string) => {
    toggleLoading(true);

    UploadImage(
      webDesigner.props.siteData.userContext,
      filename,
      Base64,
      (data: any) => {
        if (page){

          const openGURL = webDesigner.props.siteData.userContext
          .isAdmin
          ? "https://f745786de3dd98dac855-36e09dc6f87385bab9d0e7ff5c0d38c7.ssl.cf2.rackcdn.com/WB/" +
            siteData.userContext.layoutId +
            "/" +
            data
          : siteData.cdnUrl + "Websitebuilder/" + data;


          setNewOpenGraph(openGURL);
          if(tempPage)
            tempPage.openGraphImageUrl = openGURL;
          //page.openGraphImageUrl = openGURL;


        }
        toggleLoading(false);
      },
      (error: any) => {
        AlertConfirm("Error Uploading Image, Please Try Again Later");
      },
      () => {
        toggleLoading(false);
      }
    );
  };

  const EditStyleImageConfirmation = () => {
    const Element = document.getElementById("generalupload");
    if (Element) {
      Element.click();
    }
  };
  const DeleteGraphImage = () => {
    if (!page) return;

    DestructiveConfirmation(
      `Are you sure you want to permanently delete this image?`,
      () => {

        toggleLoading(true);
       
        //page.openGraphImageUrl = "";
        setNewOpenGraph("");
        let fInput = document.getElementById('generalupload');          
                            
       if(fInput){
          let f = fInput as HTMLInputElement;
          f.value = "";
          f.files = null;    
       }
    
       if(tempPage)tempPage.openGraphImageUrl = "";              
        toggleLoading(false);               
      },
      () => {},
      "delete-image-confirm",
      "Delete Image"
    );
  };

  const WithTooldtip = (props: any) => (
    <OverlayTrigger
      trigger={["hover","focus"]}
      overlay={<Tooltip id={props.id}>{props.title}</Tooltip>}
    >
      {props.children}
    </OverlayTrigger>
  );


        //eslint-disable-next-line
  const [isLoading, setLoading] = useState(false);

  if (centerGrid)
    return ReactDOM.createPortal(
      <>
        {page != null ? (
          <div
            className="nice-scroll block-edit page-edit-panel max-100 relative"
            style={style as any}
            ref={mainPage}
          >
            <div className="block-edit" style={{width:"100vw",background:"none",height:"100vh",position:"fixed",left:"1000px",zIndex:"100",top:"0"}} onClick={(e)=>{e.preventDefault();e.stopPropagation();}}></div>

            <div key={page.id}>
              <div
                className="flex-row page-menu-header"
                style={{ justifyContent: "space-between" }}
              >
                <h2 style={{ paddingLeft: "0px" }}> {page.name}</h2>
                <div
                  key="page-options-row"
                  className="flex-row pagesetting-bnts"
                  
                >
                  <WithTooldtip id="t1" title="Duplicate">
                    <button
                      className="invisible-button"
                      onClick={() => {
                        if(siteData.isModifyAllowed)
                          duplicateFunc(page);
                        else
                          AlertConfirm("You do not have permission to duplicate pages")

                      }}
                      data-tooltip="duplicate"
                    >
                      <DuplicateIcon />
                    </button>
                  </WithTooldtip>
                  <WithTooldtip id="t2" title="Delete">
                    <button
                      className="invisible-button"
                      onClick={() => {
                        if(siteData.isModifyAllowed)
                          tryDelete(page);
                        else
                          AlertConfirm("You do not have permission to delete pages")
                      }}
                      data-tooltip="delete"
                    >
                      <DeleteIcon />
                    </button>
                  </WithTooldtip>
                  <button
                    className="publish-button secondary"
                    onClick={() => {



                      if (
                        page.name != nameInput.current?.value ||
                        (page.isExternalLink && (page.url != slugInput.current?.value||(page.isExternalLinkNewTab??false)!=(newTabInput.current?.checked))) ||
                        (page.type == PageType.Page &&!page.isExternalLink&& (page.metaDescription !=metaDescInput.current?.value ||page.titleTag != titleTagInput.current?.value ||page.isDisabled !=diablePageInput.current?.checked||page.openGraphImageUrl!=newOpenGraph)) ) {
                        GenericConfirmation(
                          `1 You have unsaved ${
                            page.type == PageType.Page ? "page" : "folder"
                          } changes, are you sure you want to close without saving?`,
                          () => {
                            setNewOpenGraph(page.openGraphImageUrl);
                            closeFunc();
                          },
                          () => {},
                          "page-close-cnfm",
                          "Close without saving",
                          "Close",
                          "Cancel",
                          true
                        );
                      } else closeFunc();
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="publish-button"
                    disabled={
                      nameValidation.length > 0 || urlValidation.length > 0
                    }
                    onClick={() => {
                      
                      if(siteData.isModifyAllowed)
                      savePageData();
                      else
                        AlertConfirm("You do not have permission to save pages")
                      
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
              <div className="flex-column wb-input-group no-border">
                <span className="flex-row justify-between">
                  <label>{folderOrPage} Name:</label>
                  <span className="validation-label">{nameValidation}</span>
                </span>
                <input
                  ref={nameInput}
                  id="page-name-input"
                  type="text"
                  defaultValue={page.name}
                  placeholder={folderOrPage + " Name"}
                  maxLength={maximumPageNameLength}
                  onBlur={(e) => {

                    if(e.target.value){
                      e.target.value = e.target.value.trim();
                    }

                  }}
                  onInput={(e) => {
                    updateNameInput(page,e, folderOrPage);
                    UpdateInputAndPreview(e, "name");
                  }}
                />
              </div>

              {page.type == PageType.Page && (
                <div className="flex-column wb-input-group no-border">
                  <span className="flex-row justify-between">
                    {" "}
                    <label>{page.isExternalLink?"Link URL:":"URL Slug:"}</label>
                    <span className="validation-label">{urlValidation}</span>
                  </span>
                  <div className="flex-row w-full">
                 {/* {page.isExternalLink&&<div style={{userSelect:"none",border:"1px solid #e7e7e7",borderRight:"none",fontSize:"14px",fontWeight:"400", lineHeight:"40px",background:"#f7f7f7",padding:"0 8px",position:"relative",zIndex:"1"}}>
                  {"https:// "}
                  </div>} */}
                  <input
                    ref={slugInput}
                    // style={(page.isExternalLink)?{borderRadius:"0 4px 4px 0"}:{}}
                    className="w-full"
                    type="text"
                    defaultValue={page.url}
                    placeholder={ page.isExternalLink?"https://": (folderOrPage + " url")}
                    maxLength={80}
                    onInput={(e) =>{ 
                     
                        UpdateInputAndPreview(e, !page.isExternalLink?"url":"external-link")
                    }}
                  />
                  </div>
                </div>
              )}
              {page.isExternalLink&& <div className="flex-column wb-input-group no-border"> 

                <ToggleLine
                  label={"Open in new tab"}
                  description={
                    "If enabled, the link will open in a new tab when clicked."
                  }
                  toggledOn={page.isExternalLinkNewTab?true:false}
                  checkRef={newTabInput}
                  onChange={(on: boolean) => {
                    if(tempPage)
                      tempPage.isExternalLinkNewTab = on;
                    }
                  }
                />
                
              </div>
                  }

{!page.isExternalLink&&<Fragment>
              
              <div
                key="hide-if-folder"
                style={{
                  display: page.type === PageType.Folder ? "none" : "block",
                }}
              >
                <div className="flex-column wb-input-group no-border">
                  <label>Search Results Preview:</label>
                  <div
                    className="flex-column "
                    style={{
                      padding: "8px",
                      border: "1px solid #CDCDCD",
                      borderRadius: "3px",
                    }}
                  >
                    <h4
                      id="search-preview-title"
                      style={{
                        color: "#1A0DAB",
                        margin: "0",
                        fontWeight: "400",
                        whiteSpace:"break-spaces"
                      }}
                    >
                      {page.titleTag && page.titleTag.length > 0
                        ? page.titleTag
                        : page.name}
                    </h4>
                    <div
                      id="search-preview-url"
                      style={{ color: "#026621", fontWeight: "400", whiteSpace:"break-spaces",  wordWrap:"break-word" }}
                    >
                      {rootURL + page.url}
                    </div>
                    <div
                      id="search-preview-desc"
                      style={{
                        color: "#333333",
                        fontWeight: "400",
                        maxWidth: "100%",
                        whiteSpace: "break-spaces",
                        
                      }}
                    >
                      {page.metaDescription}
                    </div>
                  </div>
                </div>

                <div className="flex-column wb-input-group no-border">
                  <label>Title Tag:</label>
                  <input
                    type="text"
                    ref={titleTagInput}
                    defaultValue={page.titleTag}
                    placeholder="Page Name"
                    maxLength={80}
                    onInput={(e) => UpdateInputAndPreview(e, "title")}
                  />
                </div>

                <div className="flex-column wb-input-group no-border">
                  <label>Meta Description:</label>
                  <textarea
                    placeholder="This app will allow you to find salons, spas"
                    maxLength={160}
                    ref={metaDescInput}
                    defaultValue={page.metaDescription}
                    onInput={(e) => UpdateInputAndPreview(e, "desc")}
                  />
                </div>

                <div className="form-row large wb-input-group no-border">
                  <label>Open Graph Image:</label>
                  {newOpenGraph !== "" && (
                    <div
                      className="drop-file-upload webclip py-t8 uploaded"
                      style={{
                        backgroundImage: `url('${newOpenGraph}')`,
                      }}
                    >
                      <div className="showdelete d-flex flex-column">
                        <div className="p-2">
                          <a onClick={() => EditStyleImageConfirmation()}>
                            Edit
                          </a>
                        </div>
                        <div className="p-2">
                          <a
                            onClick={() => {
                              DeleteGraphImage();
                            }}
                          >
                            Delete
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                  <div
                    className="drop-file-upload  py-t8"
                    id="opengraph-upload"
                    style={{ display: newOpenGraph !== "" ? "none" : "flex" }}
                  >
                    <i className="far fa-cloud-upload" />
                    <span className="upload-note">
                      Drag and drop files here or
                    </span>
                    <span className="upload-trigger">Choose File</span>
                    <FileUpload
                      id="graph-upload-input"
                      height={1024}
                      width={1024}
                      Message="Maximum Width and Height 1024X1024"
                      allowFlexibleSize={true}
                      onInvalid ={()=>{
                            let dom = document.getElementById("generalupload") as any;
                            if(dom){
                              dom.value = "";//clear file upload control
                            }
                    }}
                      ValidFileExtensionMessage="Upload a valid PNG or JPG image."
                      FileExtension="/(png|jpg|jpeg|PNG|JPG|JPEG)$/i"
                      savecdn={UploadGraphImage}
                      setLoading={setLoading}
                    ></FileUpload>
                  </div>
                </div>
              </div>
              {page.type == PageType.Page && siteData.isModifyAllowed && (
                <ToggleLine
                  label={"Set as Home Page"}
                  description={
                    "Only one page can be set as the Home Page for the whole website"
                  }
                  toggledOn={page.isLandingPage}
                  checkRef={landingPageInput}
                  onChange={(on: boolean) => {

             
                    const homePageId = webDesigner.props.siteData.homePageId;

              
                    if (on) {

                      if(tempPage?.isDisabled){
                        if(landingPageInput.current)
                          landingPageInput.current.checked = false;
                          PageWarningToast(`Your Home Page can't be  ${(tempPage.isDisabled?"disabled":"hidden")}`);
                        return;
                      }

                      if (homePageId === "") {
                        let prevPage = {...page};
                        webDesigner.props.siteData.homePageId = page.id;
                        page.isLandingPage = true;
                        saveFunc(page,prevPage,false);
                        //onUpdateTo();
                      } else {
                        let foundPage: PageListItem | null = null;
                        for (let i = 0; i < allPages.length; i++) {
                          if (allPages[i].id === homePageId) {
                            foundPage = allPages[i];
                            break;
                          }
                        }
              
                     

                       if (foundPage != null && foundPage!=page) {
                          Confirmation(
                            <>
                              Do you want to switch the homepage from{" "}
                              <strong>{foundPage.name}</strong> and assign it to{" "}
                              <strong>{page.name}</strong>?
                            </>,
                            () => {

                              let prevPage = {...page};
                              webDesigner.props.siteData.homePageId = page.id;
                              page.isLandingPage = true;

                                

                              saveFunc(page,prevPage,false);
                              if (foundPage) {
                                foundPage.isLandingPage = false;
                                saveFunc(foundPage,prevPage,false);
                              }
                           
                              //onUpdateTo();
                            },
                            () => {
                              if (landingPageInput.current)
                                landingPageInput.current.checked = false;
                            },
                            undefined,                            
                            "Set New Home Page",
                            "Set Home Page" 

                          );
                        } else {
                          let prevPage = {...page};
                          webDesigner.props.siteData.homePageId = page.id;
                          page.isLandingPage = true;
                          saveFunc(page,prevPage,false);
                          //onUpdateTo();
                        }
                        //SaveSiteStyle( webDesigner.props.siteData)
                      }
                    } else {
                      if (webDesigner.props.siteData.homePageId === page.id) {
                        let otherPages = false;
                        for(let i = 0;i<allPages.length;i++){

                          if(allPages[i].id!=page.id&&allPages[i].type==PageType.Page&&!allPages[i].isDisabled){
                            otherPages = true;
                          }
                        }

                        if(otherPages){
                        assignHomePage(saveFunc,page.id);

                          page.isLandingPage = false;
                          if(tempPage)
                          tempPage.isLandingPage = false;
                        }

                        else{
                          PageWarningToast("Can't remove "+page.name+" as Home Page as there are no other pages available");
                   
                          if(landingPageInput.current)
                          landingPageInput.current.checked = true;
                        }
                     
                      }
                    }
                  }}
                />
              )}

              {((webDesigner.props.siteData.isMultipleLocation && MultiLocationLive) || webDesigner.props.siteData.userContext.isAdmin || (webDesigner.props.siteData.userContext.userType === LoginUserType.VagaroAdmin && webDesigner.props.siteData.isMultipleLocation)) &&
                  <ToggleLine
                    label={"Duplicate for All Locations"}
                    description={
                      <>{ folderOrPage === "Page"
                        ? "Enable this feature to automatically duplicate this page for all selected locations. All Vagaro components within the page will sync with their respective locations. Select locations in "
                        : "Enable this feature to automatically duplicate this folder and all the pages within for the selected location. All Vagaro components with each page will sync with their respective locations. Select locations in "}
                        <a  style={{color:"#2479c7"}} onClick={(e)=>{
                          e.stopPropagation();
                          e.preventDefault();
                          webDesigner.openToMultiLocationSettings();
                        }}>{"Multi-Location Settings."}</a>{ folderOrPage === "Page"
                          ? " Enabling this feature will automatically enable ‘Hide Page from Menu’."
                          : " Enabling this feature will automatically enable ‘Hide Folder from Menu’."}
                    </>

                    }
                    toggledOn={page.isDuplicateAllLocationPage}
                    checkRef={isDuplicateAllLocationPageInput}
                    onChange={(on: boolean) => {                      

                      if(tempPage?.folderId){
                        let folder = allPages.find((p)=>p.id==tempPage?.folderId);
                        if(folder){
                          if(folder.isDuplicateAllLocationPage){
                            if(isDuplicateAllLocationPageInput.current)
                              isDuplicateAllLocationPageInput.current.checked = true;

                            PageWarningToast("Unable to change page setting, its parent folder is set to 'Duplicate for All Locations' and needs to be disabled first.");
                            return;
                          }
                        }
                      }
                      if(tempPage)
                        tempPage.isDuplicateAllLocationPage = on;
    
                        if(tempPage?.isDuplicateAllLocationPage){
                          tempPage.isHidePage = true;
                          tempPage.isDisabled = false;
                          if(diablePageInput.current)
                            diablePageInput.current.checked = false;
                          if(hidePageInput.current)
                            hidePageInput.current.checked = true;      
                        }      

                        // if(landingPageInput.current?.checked&&tempPage&&tempPage.isHidePage){
                        //   tempPage.isHidePage = false;
                        //   if(hidePageInput.current)
                        //     hidePageInput.current.checked = false;
                        //     PageWarningToast("Your home page can't be hidden.");
    
                        // }
                      
                  
                    }}
                  />
              }
              
              
              <ToggleLine
                label={"Hide " + folderOrPage + " From Menu"}
                description={
                  folderOrPage === "Page"
                    ? "Hidden pages are not shown in the navigation menu, but can still be accessed through its URL."
                    : "Hidden folders are not shown in the navigation menu. All the pages within the folder will be hidden from menu, but the pages can still be accessed through their URLs."
                }
                toggledOn={page.isHidePage}
                checkRef={hidePageInput}
                onChange={(on: boolean) => {


                  if(page.folderId){
                    let folder = allPages.find((p)=>p.id==page.folderId);

                    if(folder){

                      if(!on){
                    
                          if(folder.isHidePage){
    
                            if(hidePageInput.current)
                              hidePageInput.current.checked = true;
                            
                              PageWarningToast("Unable to change page setting, its parent folder is hidden and needs to be enabled first");
                            //AlertConfirm("You can't enable this page as the parent folder is hidden");
                            return;
                          }
                      }
                      else{
                     
                          if(folder.isDisabled){
    
                            if(hidePageInput.current)
                              hidePageInput.current.checked = false;
                            
                              PageWarningToast("Unable to change page setting, its parent folder is disabled and needs to be enabled first.");
                            return;
                          }
                     
                        
                      }
                    }

                  }

                   if(!on&&isDuplicateAllLocationPageInput.current?.checked){
                    if(hidePageInput.current)
                      hidePageInput.current.checked = true;
                    PageWarningToast(`Unable to change ${folderOrPage.toLowerCase()} setting, duplicated ${folderOrPage.toLocaleLowerCase()}s must be hidden`);
                    return;

                  }

    


                  if(tempPage)
                    tempPage.isHidePage = on;

                    if(on && tempPage?.isDisabled){
                      tempPage.isDisabled = false;
                      if(diablePageInput.current)
                        diablePageInput.current.checked = false;

                    }

                    // if(landingPageInput.current?.checked&&tempPage&&on){
                    //   tempPage.isHidePage = false;
                    //   if(hidePageInput.current)
                    //     hidePageInput.current.checked = false;

                    //     PageWarningToast("Your home page can't be hidden.");

                    // }

                }}
              />

              <ToggleLine
                label={"Disable " + folderOrPage}
                description={
                  folderOrPage === "Page"
                    ? "Disabled pages can't be accessed by your site visitors."
                    : "Disabled folder can’t be accessed by any site visitors, and all the pages within the folder are disabled."
                }
                toggledOn={page.isDisabled}
                checkRef={diablePageInput}
                onChange={(on: boolean) => {
                  if(page.folderId){
                    let folder = allPages.find((p)=>p.id==page.folderId);

                    if(folder){
                      if(!on){
              
                        if(folder.isDisabled||folder.isHidePage){

                          if(diablePageInput.current)
                            diablePageInput.current.checked = true;
                            PageWarningToast(`Unable to change page setting, its parent folder is ${(folder.isDisabled?"disabled":"hidden")} and needs to be enabled first.`);
                          
                          return;
                        }
                

                      }
                      else{
                        if(folder.isHidePage){

                          if(hidePageInput.current)
                            hidePageInput.current.checked = false;
                          if(isDuplicateAllLocationPageInput.current){
                            isDuplicateAllLocationPageInput.current.checked = false;
                          }

                          if(tempPage){
                            tempPage.isDisabled = true;
                            tempPage.isDuplicateAllLocationPage = false;
                            tempPage.isHidePage = false;
                          }
                          return;
                        }
                      }
                    }

                  }


        
                  
        

                  if(tempPage)
                    tempPage.isDisabled = on;
                    if(on && tempPage?.isHidePage){

                      if(tempPage.isDuplicateAllLocationPage){
                        tempPage.isDuplicateAllLocationPage = false;
                        if(isDuplicateAllLocationPageInput.current)
                          isDuplicateAllLocationPageInput.current.checked = false;
                      }

                      tempPage.isHidePage = false;
                      if(hidePageInput.current)
                        hidePageInput.current.checked = false;
                    }

                    if(landingPageInput.current?.checked&&tempPage&&on){
                      tempPage.isDisabled = false;
                      if(diablePageInput.current)
                        diablePageInput.current.checked = false;

                      PageWarningToast("Your home page can't be disabled.");

                    }


                }}
              />
              </Fragment> }
            </div>
          </div>
        ) : (
          <div className="nice-scroll" style={style as any}></div>
        )}
      </>,

      centerGrid as Element
    );
  else {
    return <></>;
  }
}


function HomeHeartIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginLeft: "-3px" }}
      fill="currentColor"
      height="1em"
      viewBox="0 0 576 512"
    >
      <path d="M511.8 287.6H576V240L288.4 0 0 240v47.6H64.1V512H512.8l-1-224.4zM176 267.2c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L288 400.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z" />
    </svg>
  );
}

function PlusFolderIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.625 3.6875H8.55664L7.12109 2.36914C6.76953 2.01758 6.30078 1.8125 5.80273 1.8125H2.375C1.32031 1.8125 0.5 2.66211 0.5 3.6875V13.0625C0.5 14.1172 1.32031 14.9375 2.375 14.9375H13.625C14.6504 14.9375 15.5 14.1172 15.5 13.0625V5.5625C15.5 4.53711 14.6504 3.6875 13.625 3.6875ZM14.0938 13.0625C14.0938 13.3262 13.8594 13.5312 13.625 13.5312H2.375C2.11133 13.5312 1.90625 13.3262 1.90625 13.0625V3.6875C1.90625 3.45312 2.11133 3.21875 2.375 3.21875H5.80273C5.91992 3.21875 6.03711 3.27734 6.125 3.36523L8 5.09375H13.625C13.8594 5.09375 14.0938 5.32812 14.0938 5.5625V13.0625ZM10.3438 8.60938H8.70312V6.96875C8.67383 6.58789 8.38086 6.26562 8 6.26562C7.58984 6.26562 7.29688 6.58789 7.29688 6.96875V8.60938H5.62695C5.24609 8.60938 4.95312 8.93164 4.95312 9.3125C4.95312 9.72266 5.24609 10.0156 5.62695 10.0156H7.26758V11.6562C7.29688 12.0664 7.58984 12.3594 8 12.3594C8.38086 12.3594 8.67383 12.0664 8.67383 11.6855V10.0156H10.3145C10.7246 10.0156 11.0469 9.72266 11.0469 9.3125C11.0469 8.93164 10.7246 8.60938 10.3438 8.60938Z"
        fill="#333333"
      />
    </svg>
  );
}

function PlusExternalLinkIcon() {

  return <svg  height="14"


  fill="#333" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M314.2 197.8c51.1 51.1 54.4 132.3 9.8 187.2-6.2 7.7-2.8 3.9-84.9 86-54.7 54.7-143.3 54.7-198 0-54.7-54.7-54.7-143.3 0-198 32.8-32.8 51.8-51.9 63.4-63.5 7.5-7.5 20.3-2.4 20.5 8.2a173.3 173.3 0 0 0 4.7 37.8c1 4-.3 8.3-3.2 11.2L80.6 312.6c-32.8 32.8-32.9 85.9 0 118.8 32.8 32.8 85.9 32.9 118.8 0l75.2-75.2c32.7-32.7 32.8-86 0-118.8a83.7 83.7 0 0 0 -22.8-16.2c-4.6-2.2-7.2-7.3-6.6-12.3 1.4-11.1 6.3-21.9 14.8-30.4l4.4-4.4c3.6-3.6 9.2-4.6 13.8-2.3 13 6.5 25.2 15.2 36 26zM471 41c-54.7-54.7-143.3-54.7-198 0-82.2 82.2-78.7 78.3-84.9 86-44.6 54.9-41.3 136.1 9.8 187.2 10.8 10.8 23 19.5 36 26 4.6 2.3 10.1 1.3 13.8-2.3l4.4-4.4c8.5-8.5 13.5-19.3 14.8-30.4 .6-5.1-1.9-10.1-6.6-12.3a83.7 83.7 0 0 1 -22.8-16.2c-32.8-32.8-32.7-86.1 0-118.8l75.2-75.2c32.9-32.9 86-32.8 118.8 0 32.9 32.9 32.8 86 0 118.8l-45.8 45.8c-2.9 2.9-4.2 7.2-3.2 11.2a173.3 173.3 0 0 1 4.7 37.8c.2 10.5 13 15.6 20.5 8.2 11.6-11.6 30.6-30.7 63.4-63.5 54.7-54.7 54.7-143.3 0-198z"/></svg>
}

function PlusPageIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="16"
      width="16"
      viewBox="0 0 12 16"
      fill="#333"
    >
      <path
        d="M11.0684 3.62891L8.87109 1.43164C8.51953 1.08008 8.05078 0.875 7.55273 0.875H2.25C1.19531 0.875 0.375 1.72461 0.375 2.75V14C0.375 15.0547 1.19531 15.875 2.25 15.875H9.75C10.7754 15.875 11.625 15.0547 11.625 14V4.94727C11.625 4.44922 11.4199 3.98047 11.0684 3.62891ZM10.2188 14C10.2188 14.2637 9.98438 14.4688 9.75 14.4688H2.25C1.98633 14.4688 1.78125 14.2637 1.78125 14V2.7793C1.78125 2.51562 1.98633 2.31055 2.25 2.31055H6.9375V4.625C6.9375 5.15234 7.34766 5.5625 7.875 5.5625H10.2188V14ZM6.70312 7.4375C6.70312 7.05664 6.38086 6.73438 6 6.73438C5.58984 6.73438 5.29688 7.05664 5.29688 7.4375V9.07812H3.65625C3.24609 9.07812 2.95312 9.40039 2.95312 9.78125C2.95312 10.1621 3.24609 10.4551 3.65625 10.4551H5.29688V12.0957C5.29688 12.5352 5.58984 12.8281 6 12.8281C6.38086 12.8281 6.70312 12.5352 6.70312 12.1543V10.4844H8.34375C8.72461 10.4844 9.04688 10.1621 9.04688 9.78125C9.04688 9.42969 8.72461 9.10742 8.34375 9.10742H6.70312V7.4375Z"
        fill="#333333"
      />
    </svg>
  );
}

function XMark(){
  return <svg xmlns="http://www.w3.org/2000/svg" height="1.1em" fill="currentColor" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
}

function PageWarningToast(message:string){

  CustomColorToast(message,"#b3211d","white",<XMark/>,"5.5s");
}





function GetPagePosition(page:PageListItem,allPages:PageListItem[]){

  let position = 0;
  let folderDepth = 0;
  for(let i = 0;i<allPages.length;i++){
    if(allPages[i].id == page.id)
      break;
    position += 36;
    if(allPages[i].type == PageType.Folder)
      folderDepth++;
    else if(allPages[i].type == PageType.EndFolder)
      folderDepth--;
  }
  return position;
}

enum PItemType{
  Page,
  Folder,
  EndFolder,
  EndList
}

type PItem = {
  type: PItemType;
  name: string;
  url: string;
  index: number;
  folderDepth: boolean;
  folderName: string;
  folderId?: string;
  id: string;
  isExternalLink: boolean;
  titleTag?: string;
  metaDescription?: string;
  isDisabled: boolean;
  openGraphImageUrl: string;
  isLandingPage: boolean;
  isHidePage: boolean;
  isDuplicateAllLocationPage:boolean;
};




function PageMenuRedo({siteData,webDesigner}:{siteData:SiteData,webDesigner:WebDesigner}){

    const [pages,setPages] = useState<PageListItem[]>([]);  

    const [draggedPage,setDraggedPage] = useState<PageListItem | null>(null);

    const RenderPageItem = useCallback(({page}:{page:PageListItem})=>{
      return <div key={page.id}>{page.name}</div>
    },[])
  
    return <>
      {
        pages.map((page)=>{
          return <RenderPageItem page={page}/>
        })
      }
    
    </>


}